// Primary palette from design screenshot 1 (Material 3 greens)

const colors = {

  primary: "#006A4E",

  onPrimaryFixedVar: "#002117",

  primaryContainer: "#008764",

  primaryFixed: "#8AF3CE",

  primaryFixedDim: "#6ED6B3",



  background: "#FAFDFB",

  surfaceLowest: "#FFFFFF",

  surfaceLow: "#F0F4F3",

  surfaceContainer: "#DAE4E2",

  surfaceVariant: "#BEC9C6",

  onSurfaceVariant: "#4F5E5B",

  error: "#BA1A1A",

  errorContainer: "#FFDAD6",

  tertiary: "#7D4E46",

  tertiaryContainer: "#C4867A",

};



module.exports = colors;

